(()=>{
 document.addEventListener('click', function (event) {
    const btn = event.target.closest('.zenoti_btn');
    if (!btn) return;

    const href = btn.getAttribute('href') || btn.dataset.href || '';
    if (!href || !href.includes('book.reecess.com')) return;

    Shopify.analytics.publish('book_now_clicked', {
      link_url: href,
      link_text: btn.textContent.trim(),
      timestamp: new Date().toISOString()
    });
  });
})()

function updateCenterSlide() {
  document.querySelectorAll('.reviews--section .reviews__grid-item.center-slide').forEach(el => {
    el.classList.remove('center-slide');
  });
  const activeSlides = document.querySelectorAll('.reviews--section .reviews__grid-item.is-visible');
  if (activeSlides.length === 3) {
    activeSlides[1].classList.add('center-slide'); 
  }
}
setTimeout(updateCenterSlide, 500);

/*
 Custom Paginations for slider 
 Properties:
 data-custom-dots="true" = Boolean
 data-slides-to-scroll="X" = Number
 data-slides-to-scroll-M="X" = Number
*/

class SliderPagination {
  constructor(sliderClass = 'grid--slider') {
    this.sliders = document.querySelectorAll(`.${sliderClass}[data-custom-dots="true"]`);
    this.activeDotLock = false;
    this.isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (this.sliders.length) {
      this.initSliders();
      window.addEventListener('resize', () => {
        const newIsMobile = window.matchMedia('(max-width: 767px)').matches;
        if (newIsMobile !== this.isMobile) {
          this.isMobile = newIsMobile;
          this.recreateAllPagination();
        }
      });
    }
  }

  recreateAllPagination() {
    document.querySelectorAll('.slider-pagination__wrapper').forEach(el => el.remove());
    this.initSliders();
  }

  initSliders() {
    this.sliders.forEach(slider => {
      const slidesToScroll = this.getSlidesToScroll(slider);
      const wrapper = document.createElement('div');
      wrapper.className = 'slider-pagination__wrapper';

      const pagination = document.createElement('div');
      pagination.className = 'slider-pagination';

      wrapper.appendChild(pagination);
      slider.parentNode.insertBefore(wrapper, slider.nextSibling);

      const items = slider.children;
      const dotCount = Math.ceil(items.length / slidesToScroll);

      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.className = 'slider-pagination__dot';
        dot.dataset.slideIndex = i;
        dot.ariaLabel = `Go to slide ${i + 1}`;
        
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          this.activeDotLock = true;
          this.setActiveDot(pagination, i);
          updateCenterSlide();
          this.scrollToGroup(slider, i, slidesToScroll);
          setTimeout(() => this.activeDotLock = false, 1000);
        });
        
        pagination.appendChild(dot);
      }

      if (dotCount > 0) pagination.firstChild.classList.add('active');
      
      let scrollTimeout;
      slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (!this.activeDotLock) this.updateActiveDot(slider, slidesToScroll);
          updateCenterSlide();
        }, 100);
      });
    });
  }

  getSlidesToScroll(slider) {
    const mobileAttr = this.isMobile ? 'slidesToScrollM' : 'slidesToScroll';
    const slidesToScroll = slider.dataset[mobileAttr] || slider.closest(`[data-${mobileAttr}]`)?.[mobileAttr] || slider.dataset.slidesToScroll || slider.closest('[data-slides-to-scroll]')?.dataset.slidesToScroll;
    const result = parseInt(slidesToScroll);
    return isNaN(result) || result < 1 ? 1 : result;
  }

  scrollToGroup(slider, groupIndex, slidesToScroll) {
    const items = slider.children;
    const firstSlideIndex = groupIndex * slidesToScroll;
    if (firstSlideIndex >= 0 && firstSlideIndex < items.length) {
      updateCenterSlide();
      slider.scrollTo({
        left: items[firstSlideIndex].offsetLeft - slider.offsetLeft,
        behavior: 'smooth'
      });
    }
  }

  setActiveDot(pagination, activeIndex) {
    Array.from(pagination.children).forEach((dot, i) => {
      dot.classList.toggle('active', i === activeIndex);
    });
  }

  updateActiveDot(slider, slidesToScroll) {
  const wrapper = slider.nextElementSibling;
if (!wrapper?.classList.contains('slider-pagination__wrapper')) return;

const pagination = wrapper.querySelector('.slider-pagination');
if (!pagination) return;

  
  const scrollLeft = slider.scrollLeft;
  const itemWidth = slider.children[0].offsetWidth;
  const outer = parseInt(getComputedStyle(slider).getPropertyValue('--outer')) || 0;
  const totalWidth = slider.scrollWidth - slider.clientWidth;
  const atEnd = Math.abs(scrollLeft - totalWidth) < 50;
  if (atEnd) {
    this.setActiveDot(pagination, pagination.children.length - 1);
  } 
  else {
    const activeGroupIndex = Math.max(0, Math.min(
      Math.floor(Math.round(scrollLeft / (itemWidth + outer)) / slidesToScroll),
      pagination.children.length - 1
    ));
    this.setActiveDot(pagination, activeGroupIndex);
  }
}
}

document.addEventListener('DOMContentLoaded', () => new SliderPagination());



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".drawer__menu .sliderow__title").forEach(function (title) {
    title.addEventListener("click", function () {
      const wrapper = this.closest(".drawer__menu .sliderow-wrap");
      if (wrapper) {
        wrapper.classList.toggle("open");
      }
    });
  });
});


(function() {
  // Add custom code below this line

  // Mute button logic
  document.addEventListener("DOMContentLoaded", function () {
    const toggleButtons = document.querySelectorAll('.video-mute-toggle');

    toggleButtons.forEach((button) => {
      // Prevent Flickity drag capture
      button.addEventListener('pointerdown', e => e.stopPropagation());
      button.addEventListener('touchstart', e => e.stopPropagation());

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log("clicked");
        

        const videoId = this.dataset.videoId;
        const video = document.getElementById(videoId);
        if (!video) return;

        video.muted = !video.muted;
        this.classList.toggle('is-muted', video.muted);
      });
    });
  });
  

    // PDP Desc Read more Logic
    document.addEventListener("DOMContentLoaded", function () {
    const readMore = document.getElementById("read-more");
    const readLess = document.getElementById("read-less");
    const truncated = document.getElementById("truncated-description");
    const full = document.getElementById("full-description");

    if (readMore && readLess && truncated && full) {
      readMore.addEventListener("click", function () {
        truncated.style.display = "none";
        full.style.display = "block";
      });

      readLess.addEventListener("click", function () {
        full.style.display = "none";
        truncated.style.display = "block";
      });
    }
  });


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
